var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._v(" "+_vm._s(_vm.item.label)+": "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.item.value))])])]}}])},[_c('span',{class:((_vm.arabic?'arFont':'enFont') + " pa-0")},[_vm._v(" "+_vm._s(_vm.item.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }